import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_site/legal/impressum")({
  head: () => ({ meta: [{ title: "Impressum — NexKey.gg" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <article>
      <h1 className="font-display text-3xl font-bold">Impressum</h1>
      <p className="mt-4 text-sm text-muted-foreground">
        Angaben gemäß § 5 TMG. This is a placeholder page — the operator must replace this content with
        their real Impressum information before going live.
      </p>
      <h2 className="mt-6 font-display text-lg font-semibold">Anbieter</h2>
      <p className="text-sm text-muted-foreground">[Name / Firma]<br />[Adresse]<br />[Stadt, PLZ]<br />[Land]</p>
      <h2 className="mt-6 font-display text-lg font-semibold">Kontakt</h2>
      <p className="text-sm text-muted-foreground">[E-Mail]<br />[Telefon]</p>
    </article>
  ),
});
